export default __webpack_public_path__ + "img/449d5670ced6f71a2b2d0f47d1e1a0ab.svg";